$('a[href^="#"]').on("click", function () {
  const speed = 500;
  const easing = "swing";
  const href = $(this).attr("href");
  const target = $(href == "#" || href == "" ? "html" : href);
  const spt = parseInt($("html").css("scrollPaddingTop")) || 0;
  const smt = parseInt($(target).css("scrollMarginTop")) || 0;
  // スクロール先
  const position = target.offset().top - (spt + smt);
  $("html, body").animate({ scrollTop: position }, speed, easing);
  return false;
});

// 外部リンクのアニメーション
var urlHash = location.hash;
var headerHeight = $(".header").outerHeight(true);
if (urlHash) {
  $("body,html").stop().scrollTop(0);
  setTimeout(function () {
    var target = $(urlHash);
    var position = target.offset().top - headerHeight;
    $("body,html").stop().animate(
      {
        scrollTop: position,
      },
      500
    );
  }, 100);
}

// SP nav
$(document).ready(function () {
  $(".js-nav-bt").on("click", function () {
    if ($(".js-nav-content").hasClass("is-navOn")) {
      $(".js-nav-content").removeClass("is-navOn");
      $(".js-nav-logo").removeClass("is-navOn");
      $(this).removeClass("is-navOn");
    } else {
      $(".js-nav-content").addClass("is-navOn");
      $(".js-nav-logo").addClass("is-navOn");
      $(this).addClass("is-navOn");
    }
  });
  $(".js-nav-bt.is-navOn, .js-nav-logo.is-navOn, .js-nav-link").on(
    "click",
    function (e) {
      // サブメニューありの項目（医院紹介・診療案内）ではメニューを閉じず、ドロップダウンを開閉する
      var $target = $(this);
      if ($target.closest(".is-subLink").length && window.matchMedia("(max-width: 1024px)").matches) {
        e.stopPropagation();
        var $li = $target.closest(".header-navList__link");
        var $sub = $li.find(".subLink").first();
        var $plus = $li.find(".js-sp-navDown").first();
        $sub.slideToggle();
        $plus.toggleClass("is-on");
        return;
      }
      $(
        ".js-nav-content.is-navOn, .js-nav-logo.is-navOn, .js-nav-bt.is-navOn"
      ).removeClass("is-navOn");
    }
  );
});

// SP用ドロップダウン（プラスアイコン）: リサイズ後も動くよう常にバインドし、SP時のみ処理
jQuery(function ($) {
  $(document).on("click", ".js-sp-navDown", function () {
    if (!window.matchMedia("(max-width: 1024px)").matches) return;
    $(this).next().slideToggle();
    $(this).toggleClass("is-on");
  });
});

if (window.matchMedia("(max-width: 1024px)").matches) {
  $(function () {
    $(window).on("scroll", function () {
      const sliderHeight = $(".topMv").height();
      if (sliderHeight - 30 < $(this).scrollTop()) {
        $(".js-header-sp").addClass("is-headerOn");
      } else {
        $(".js-header-sp").removeClass("is-headerOn");
      }
    });
  });

  $(function () {
    $(window).on("scroll", function () {
      scrollHeight = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      footHeight = $(".js-footer-sp").innerHeight();
      if (scrollHeight - scrollPosition <= footHeight) {
        $(".js-cv-sp").addClass("is-none");
      } else {
        $(".js-cv-sp").removeClass("is-none");
      }
    });
  });
}

document.querySelectorAll('.sec12-tabButton').forEach(button => {
  button.addEventListener('click', () => {
    const tab = button.dataset.tab;
    document.querySelectorAll('.sec12-tabButton')
      .forEach(btn => btn.classList.remove('is-active'));
    document.querySelectorAll('.sec12-tabContent')
      .forEach(content => content.classList.remove('is-active'));
    button.classList.add('is-active');
    document
      .querySelector('.sec12-tabContent[data-tab="' + tab + '"]')
      .classList.add('is-active');
  });
});

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("is-visible");
    }
  });
});

document.querySelectorAll(".fadeUp").forEach((el) => {
  observer.observe(el);
});
